import { render, staticRenderFns } from "./technicSettings.vue?vue&type=template&id=480d99b2&"
import script from "./technicSettings.vue?vue&type=script&lang=js&"
export * from "./technicSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports